const en = {
  translation: {
    brand: 'CrebtoPay',
    nav: {
      home: 'Home',
      dashboard: 'Buy Crypto',
      wallet: 'Wallet',
      transactions: 'Transactions',
      aiChat: 'AI Assistant',
      admin: 'Admin Panel',
      search: 'Search',
      searchCrypto: 'Search crypto',
      menu: 'Menu',
      menuSubtitle: 'Navigate between pages quickly',
      profile: 'Profile',
    },
    auth: {
      signIn: 'Sign In',
      signUp: 'Sign Up',
      signOut: 'Sign Out',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      fullName: 'Full Name',
      namePlaceholder: 'John Doe',
      processing: 'Processing...',
      welcomeBack: 'Welcome back!',
      createAccount: 'Create your account and start trading',
      haveAccount: 'Already have an account? Sign In',
      noAccount: "Don't have an account? Sign Up",
      accountCreated: 'Account created successfully!',
      welcomeToPlatform: 'Welcome to CrebtoPay',
      alreadyRegistered: 'Email already registered',
      alreadyRegisteredDesc: 'This email is already registered. Try signing in.',
      invalidCredentials: 'Invalid credentials',
      invalidCredentialsDesc: 'Email or password is incorrect.',
      emailNotConfirmed: 'Email not confirmed',
      emailNotConfirmedDesc: 'Please confirm your email first.',
      error: 'An error occurred',
      errorDesc: 'An unexpected error occurred. Please try again.',
      platformDesc: 'Our platform supports Bitcoin, Ethereum and other cryptocurrencies',
      forgotPassword: 'Forgot password?',
      validation: {
        nameMin: 'Name must be at least 2 characters',
        emailInvalid: 'Invalid email address',
        passwordMin: 'Password must be at least 6 characters',
        passwordRequired: 'Password is required',
        passwordMismatch: 'Passwords do not match',
      },
    },
    home: {
      badge: 'Secure & Licensed Platform',
      heroTitle1: 'Buy Cryptocurrency',
      heroTitle2: 'With Your Credit Card',
      heroDesc: 'A simple and secure platform to buy Bitcoin, Ethereum, and over 100 cryptocurrencies. We accept all cards worldwide.',
      startNow: 'Get Started',
      available: 'Available in 150+ countries',
      cards: 'Visa, Mastercard, Amex',
      instantOps: 'Instant transactions',
      livePrices: 'Live Prices',
      livePricesDesc: 'Updated prices for the most popular cryptocurrencies',
      whyUs: 'Why Choose Us?',
      whyUsDesc: 'We provide the best experience for buying crypto safely and quickly',
      security: 'High Security',
      securityDesc: 'Bank-grade encryption and advanced protection for your data and funds',
      speed: 'Lightning Fast',
      speedDesc: 'Instant purchases delivered to your wallet within minutes',
      global: 'Global Coverage',
      globalDesc: 'We accept cards from all countries and serve 150+ countries worldwide',
      ctaTitle: 'Start Your Crypto Journey Today',
      ctaDesc: 'Join thousands of users who trust us to buy cryptocurrency easily and securely',
      createFreeAccount: 'Create Free Account',
      copyright: '© 2024 CrebtoPay. All rights reserved.',
    },
    dashboard: {
      availableCryptos: 'Available Cryptos',
      bestPerformance: 'Best Performer Today',
      paymentMethods: 'Payment Methods',
      allCards: 'All Cards',
      availableCryptosTitle: 'Available Cryptocurrencies',
      chooseCrypto: 'Choose the currency you want to buy',
      lastUpdate: 'Last updated',
      searchPlaceholder: 'Search for a crypto...',
      refresh: 'Refresh',
      showMore: 'Show More',
      remaining: 'remaining',
      noResults: 'No cryptocurrencies match your search',
      buy: 'Buy',
    },
    wallet: {
      totalBalance: 'Total Balance',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      transfer: 'Transfer',
      receive: 'Receive',
      send: 'Send',
      assets: 'Assets',
      deposits: 'Deposits',
      withdrawals: 'Withdrawals',
      hideSmall: 'Hide small balances',
      noBalances: 'No balances yet',
      noBalancesHint: 'When you buy or deposit crypto, your balances will appear here',
      noResults: 'No results',
      noDeposits: 'No deposits',
      noWithdrawals: 'No withdrawal requests',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      depositCrypto: 'Deposit',
      depositWord: 'Deposit',
      withdrawWord: 'Withdraw',
      selectCrypto: 'Select currency',
      selectNetwork: 'Network',
      networkFee: 'Fee',
      depositAddress: 'Deposit Address',
      noAddressSet: 'No address set for network',
      yet: 'yet',
      autoDetection: 'Auto-detection enabled',
      autoDetectionDesc: 'After sending the transfer to the address above, the deposit will be detected and added to your balance automatically within minutes.',
      networkWarning: 'Only send',
      networkWarning2: 'via',
      networkWarningEnd: 'Sending via a different network may result in loss of funds.',
      withdrawCrypto: 'Withdraw Crypto',
      currency: 'Currency',
      chooseCurrency: 'Select currency',
      network: 'Network',
      chooseNetwork: 'Select network',
      amount: 'Amount',
      all: 'All',
      available: 'Available',
      walletAddress: 'Wallet Address',
      addressVerified: 'Address verified on blockchain',
      addressInvalid: 'Invalid address',
      verifyingAddress: 'Verifying address...',
      sending: 'Sending...',
      requestSent: 'Request sent',
      requestSentDesc: 'Your withdrawal will be reviewed by admin',
      copied: 'Copied',
      userName: 'Name',
      search: 'Search',
      fee: 'Fee',
      receiveTime: 'Receive time',
      minutes: 'minutes',
      internalTransfer: 'Internal Transfer',
      internalTransferDesc: 'Enter the recipient ID and amount',
      recipientId: 'Recipient ID',
      recipientIdHint: 'Enter the 16-digit user ID',
      searching: 'Searching...',
      recipient: 'Recipient:',
      idNotFound: 'ID not found',
      quantity: 'Quantity',
      selectCurrency: 'Select currency',
      transferSuccess: 'Transfer successful ✅',
      confirmTransfer: 'Confirm Transfer',
      transferring: 'Transferring...',
      chooseSendMethod: 'Choose Send Method',
      chooseSendMethodDesc: 'Select the transfer type',
      internalTransferTitle: 'Internal Transfer',
      internalTransferHint: 'Send to another user via ID',
      externalSend: 'External Send',
      externalSendHint: 'Send via wallet address and network',
      externalSendTitle: 'External Send',
      externalSendDesc: 'Send your coins to an external wallet address',
      selectCoin: 'Select currency',
      selectNetworkLabel: 'Network',
      walletAddressLabel: 'Wallet Address',
      quantityLabel: 'Amount',
      allBalance: 'All',
      availableBalance: 'Available',
      confirmSend: 'Confirm Send',
      sendingExternal: 'Sending...',
      swapTitle: 'Swap Currencies',
      swapDesc: 'Swap one currency for another with only 0.1% fee',
      swapFromLabel: 'From',
      swapToLabel: 'To',
      swapSelectCoin: 'Select currency',
      swapYouGet: 'You will receive',
      swapValueUsd: 'Value in USD',
      swapFee: 'Swap fee (0.1%)',
      swapPrice: 'Price of',
      swapConfirm: 'Confirm Swap',
      swapping: 'Swapping...',
      swap: 'Swap',
      history: 'History',
      noHistory: 'No previous transactions',
      generateAddress: 'Generate Address',
      generatingAddress: 'Generating...',
      freeTransfer: 'Free transfer — No fees',
    },
    transactions: {
      title: 'Transaction History',
      subtitle: 'All previous purchases',
      searchPlaceholder: 'Search for a currency...',
      noTransactions: 'No transactions',
      noSearchResults: 'No results found for your search',
      noTransactionsHint: "You haven't made any purchases yet. Start by buying your first cryptocurrency!",
      buy: 'Buy',
      completed: 'Completed',
      pending: 'Processing',
      failed: 'Failed',
      fee: 'Fee',
    },
    purchase: {
      buyTitle: 'Buy',
      amountUsd: 'Amount (USD)',
      yourWallet: 'Your wallet to receive the currency',
      networkLabel: 'Network',
      chooseNetwork: 'Choose network',
      fee: 'Fee',
      time: 'Time',
      walletAddressLabel: 'Your wallet address',
      walletAddressPlaceholder: 'Enter your wallet address',
      totalAmount: 'Amount',
      networkFee: 'Network fee',
      total: 'Total',
      youWillReceive: 'You will receive',
      nextCard: 'Next - Card Details',
      cardInfo: 'Card Details',
      cardNumber: 'Card Number',
      cardExpiry: 'Expiry Date',
      cardCvv: 'CVV',
      cardName: 'Cardholder Name',
      cardNamePlaceholder: 'Name as on card',
      backToDetails: 'Back',
      nextProof: 'Next - Payment Proof',
      proofTitle: 'Payment Proof',
      proofDesc: 'Transfer the amount then upload a screenshot of the payment proof',
      proofTransferTo: 'Transfer the following amount:',
      proofUpload: 'Upload payment proof image',
      proofMaxSize: 'Max: 5MB',
      proofFileTooLarge: 'File size exceeds 5MB',
      proofSubmit: 'Submit & Verify',
      proofProcessing: 'Processing...',
      proofNoFile: 'Please upload payment proof first',
      verifying: 'Verifying...',
      verifyingDesc: 'AI is verifying the payment proof',
      approvedTitle: 'Automatically Approved ✅',
      approvedDesc: 'AI verified the payment proof and approved the transaction',
      approvedTransfer: 'Will transfer',
      approvedToWallet: 'to your wallet',
      pendingTitle: 'Under Review',
      pendingDesc: 'The payment proof needs manual review by admin',
      aiWarning: 'After entering card details and uploading payment proof, AI will automatically verify and approve.',
      purchaseFailed: 'Transaction failed',
      purchaseFailedDesc: 'An error occurred. Please try again.',
      minAmount: 'Minimum purchase is $10',
      maxAmount: 'Maximum is $10,000,000',
      invalidWallet: 'Invalid wallet address',
      invalidCardNumber: 'Invalid card number',
      invalidExpiry: 'Invalid format (MM/YY)',
      invalidCvv: 'Invalid CVV',
      cardNameRequired: 'Cardholder name is required',
    },
    changePassword: {
      title: 'Change Password',
      button: 'Change Password',
      current: 'Current Password',
      new: 'New Password',
      confirm: 'Confirm Password',
      saving: 'Saving...',
      saveChanges: 'Save Changes',
      success: 'Changed successfully',
      successDesc: 'Your password has been changed.',
    },
    forgotPassword: {
      title: 'Reset Password',
      otpTitle: 'Enter Verification Code',
      newPasswordTitle: 'New Password',
      emailDesc: 'Enter your email and we will send you a 6-digit verification code.',
      otpDesc: 'Enter the 6-digit code sent to your email.',
      otpSentTo: 'Code sent to',
      otpError: 'Please enter the 6-digit code',
      newPasswordDesc: 'Enter your new password.',
      sendCode: 'Send Code',
      sending: 'Sending...',
      verify: 'Verify',
      verifying: 'Verifying...',
      codeSent: 'Sent',
      codeSentDesc: 'Check your email for the verification code.',
      codeVerified: 'Verified',
      codeVerifiedDesc: 'You can now set a new password.',
      invalidCode: 'Invalid code',
      passwordChanged: 'Success',
      passwordChangedDesc: 'Your password has been changed successfully.',
      resetButton: 'Set Password',
    },
    chat: {
      title: 'AI Assistant',
      liveSupport: 'Live Support',
      supportChat: 'Chat with support team',
      askAboutCrypto: 'Ask about cryptocurrencies',
      waiting: 'Waiting',
      connected: 'Connected',
      guest: 'Guest',
      welcomeTitle: 'Hello! How can I help you?',
      welcomeDesc: 'I can answer your questions about cryptocurrencies, buying and selling, and provide security tips for digital wallets.',
      suggestion1: 'What is Bitcoin?',
      suggestion2: 'How do I protect my wallet?',
      suggestion3: 'What is the difference between BTC and ETH?',
      needHuman: 'Need human assistance?',
      requestSupport: 'Request support agent',
      cancelSupport: 'Cancel support request',
      clearChat: 'Clear chat',
      typing: 'Typing...',
      waitingSupport: 'Waiting for support team response...',
      inputPlaceholder: 'Type your message here...',
      supportPlaceholder: 'Type your message to support team...',
      chatWithAI: 'Chat with AI Assistant',
    },
    admin: {
      title: 'Admin Dashboard',
      subtitle: 'Manage and monitor all transactions, profits and support',
      aiAssistant: 'AI Assistant',
      security: 'Security Monitor',
      users: 'Users',
      transactions: 'Transactions',
      devices: 'Devices',
      support: 'Support Messages',
      deposits: 'Deposits',
      withdrawals: 'Withdrawals',
      commission: 'Commission',
      settings: 'Settings',
      registeredUsers: 'Registered Users',
      guests: 'Guests',
    },
    common: {
      loading: 'Loading...',
      error: 'Error',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      fillAllFields: 'Please fill all fields',
      invalidAmount: 'Invalid amount',
      insufficientBalance: 'Insufficient balance',
    },
    mfa: {
      setupTitle: 'Set Up Two-Factor Authentication',
      setupDesc: 'Scan the QR code with your authenticator app (Google Authenticator or Authy)',
      scanQR: 'Scan this code with your authenticator app',
      orEnterManually: 'Or enter the code manually:',
      enterCode: 'Verification Code',
      activate: 'Activate 2FA',
      setupSuccess: 'Successfully activated!',
      setupSuccessDesc: 'Two-factor authentication is now enabled on your account',
      enrollError: 'Enrollment error',
      needRelogin: 'Please log in again to set up two-factor authentication',
      verifyTitle: 'Identity Verification',
      verifyDesc: 'Enter the verification code from your authenticator app',
      verify: 'Verify',
      verifyError: 'Verification error',
      invalidCode: 'Invalid code, please try again',
      saveSecretWarning: '⚠️ Important: Save this secret code in a safe place! You will need it if you change your phone or want to re-add the authenticator app. This code will NOT be shown again after activation.',
      resetButton: 'Reset 2FA',
      resetTitle: 'Reset Two-Factor Authentication',
      resetDesc: 'This will remove your current authenticator and require you to set up a new one.',
      resetWarning: 'After resetting, you will need to scan a new QR code with your authenticator app. Make sure you have access to your app before proceeding.',
      resetSuccess: '2FA Reset',
      resetSuccessDesc: 'Please set up your new authenticator now.',
      lostAuthenticator: 'Lost your authenticator?',
      resetViaEmail: 'Reset via Email',
      resetViaEmailDesc: 'We will send a 6-digit verification code to your email to reset your two-factor authentication.',
      sendResetCode: 'Send Verification Code',
      sendingCode: 'Sending...',
      resetOtpSent: 'Code Sent',
      resetOtpSentDesc: 'Check your email for the verification code.',
      resetOtpFailed: 'Failed to send code',
      codeSentTo: 'Code sent to',
      enterResetCode: 'Email Verification Code',
      verifyAndReset: 'Verify & Reset',
      resetOtpInvalid: 'Invalid or expired code',
      resendCode: 'Resend code',
      scanNewQR: 'Scan the new QR code with your authenticator app',
    },
    profile: {
      title: 'Profile',
      subtitle: 'Manage your personal information and security settings',
      personalInfo: 'Personal Information',
      fullName: 'Full Name',
      fullNamePlaceholder: 'Enter your full name',
      email: 'Email',
      dateOfBirth: 'Date of Birth',
      selectDateOfBirth: 'Select date of birth',
      saveChanges: 'Save Changes',
      securitySettings: 'Security Settings',
      saved: 'Saved',
      profileUpdated: 'Profile updated successfully',
      uploaded: 'Uploaded',
      avatarUpdated: 'Profile picture updated successfully',
      imageOnly: 'Please select an image only',
      imageTooLarge: 'Image must be less than 2MB',
    },
  },
};

export default en;
